import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SsoRedirectComponent} from './sso-redirect.component';

@NgModule({
  declarations: [SsoRedirectComponent],
  imports: [
    CommonModule
  ],
  exports: []
})
export class SsoRedirectModule {
}
